import { Button, Upload, UploadProps } from 'antd';
import { RcFile, UploadChangeParam, UploadFile } from 'antd/es/upload';
import { Loading } from 'components';
import GeneralHeader from 'components/common/GeneralHeader';
import { CustomInput } from 'components/custom';
import useMember from 'hooks/useMember';
import useNotice from 'hooks/useNotice';
import { useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { postFile } from 'utils';

const CustomizeDesign = () => {
  const { updateCustomizeDesign, getCustomizeDesign } = useMember();
  const { successNotification, error } = useNotice();
  const [imageUrl, setImageUrl] = useState<RcFile | string>();
  const [fileBeforeSave, setFileBeforeSave] = useState(null);
  const [data, setData] = useState({
    company_name: '',
    support_email: ''
  });
  const [nameCompany, setNameCompany] = useState('');
  const [loading, setLoading] = useState(false);
  const [checkName, setCheckName] = useState(false);
  const queryClient = useQueryClient();
  const onSubmit = () => {
    setLoading(true);
    setCheckName(false);
    if (data?.company_name === '') {
      setCheckName(true);
      setLoading(false);
    } else {
      if (data?.support_email && !validateEmail(data?.support_email)) {
        setLoading(false);
        return;
      }
      if (fileBeforeSave !== null) {
        const formData = new FormData();
        for (const key in fileBeforeSave) {
          formData.append(key, fileBeforeSave[key]);
        }
        postFile(formData).then(async (res) => {
          const t = Object.assign({ logo_id: res?.data?.id }, data);
          updateCustomizeDesign(t)
            .then((res) => {
              setNameCompany(res?.data.company_name);
              setLoading(false);
              // window.location.reload();
              successNotification('Data was change.');
              queryClient.refetchQueries({
                queryKey: 'get-logoWeb-pre',
                exact: true,
              });
            })
            .catch((err) => {
              setLoading(false);
              error('Something went wrong');
            });
        });
      } else {
        if (imageUrl !== null) {
          updateCustomizeDesign(data)
            .then((res) => {
              setNameCompany(res?.data.company_name);
              setLoading(false);
              // window.location.reload();
              successNotification('Data was change.');
            })
            .catch((err) => {
              setLoading(false);
              error('Something went wrong');
            });
        } else {
          const t = Object.assign({ logo_id: null }, data);
          updateCustomizeDesign(t)
            .then((res) => {
              setNameCompany(res?.data.company_name);
              setLoading(false);
              successNotification('Data was change.');
              queryClient.refetchQueries({
                queryKey: 'get-logoWeb-pre',
                exact: true,
              });
            })
            .catch((err) => {
              setLoading(false);
              error('Something went wrong');
            });
        }

        // }
      }
    }

  };
  useEffect(() => {
    setLoading(true);
    getCustomizeDesign().then((res) => {
      if (res) {
        setData(res);
        setNameCompany(res?.company_name);
        if (res?.logo === null) {
          setImageUrl(null);
        } else {
          setImageUrl(res?.logo?.url);
        }
        setLoading(false);
      }
    });
  }, []);
  const handleKeyDown = (e) => {
    const value = e.target.value;
    if (value.length >= 20 && e.key !== 'Backspace' && e.key !== 'Delete') {
      e.preventDefault();
    }
  };
  const handleDeleteImage = () => {
    setImageUrl(null);
    setFileBeforeSave(null);
  };
  const handleUploadImage: UploadProps['onChange'] = (
    e: UploadChangeParam<UploadFile>,
  ) => {
    const uploadedImageUrl = URL.createObjectURL(e.file.originFileObj);
    setImageUrl(uploadedImageUrl);
    setFileBeforeSave({
      file: e.file.originFileObj,
      source: 'site_configuration',
    });
  };
  const validateEmail = (email: string) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  };

  if (loading) return <Loading />;
  return (
    <GeneralHeader
      icon="/icons/customize_design.svg"
      pageTitle={nameCompany as any}
      btnComponent={
        <button
          onClick={() => onSubmit()}
          style={{ width: 40, height: 40 }}
          className="header-button"
        >
          <img src="/icons/save_button.svg" alt="button" />
        </button>
      }
      child={
        <div style={{ marginTop: 100, paddingBottom: 60 }}>
          <span
            style={{ color: '#000000' }}
            className="general_settings_employee_text"
          >
            Customize Design
          </span>
          <div
            style={{
              display: 'flex',
              gap: 16,
              margin: '40px 0px 40px 0',
              width: '100%',
            }}
          >
            <div
              style={{ width: '100%' }}
              className="general_settings_employee_container"
            >
              <div className="general_settings_employee_container_wrap">
                <span
                  style={{ color: '#000000' }}
                  className="general_settings_employee_container_text"
                >
                  Company
                </span>
              </div>
              <div style={{ width: '100%', display: 'flex', gap: 32 }}>
                <div style={{ width: "50%", display: 'flex', flexDirection: 'column' }} >
                  <CustomInput
                    maxLength={100}
                    required
                    width='100%'
                    value={(data as any)?.company_name}

                    onChange={(e) => {
                      const updatedData = {
                        ...data,
                        company_name: e.target.value,
                      };
                      setData(updatedData);
                    }}
                    error={checkName}
                    title="Name company"
                  />
                  {checkName && <div
                    style={{
                      fontSize: 10,
                      color: '#E02C2C',
                      fontWeight: 500,
                      marginTop: 2,
                    }}
                  >
                    {`"Name company" is requied.`}
                  </div>}
                </div>
                {/* <Avatar
                  src={
                    imageUrl
                      ? imageUrl && URL.createObjectURL(imageUrl as RcFile)
                      : (data as any)?.logo?.url
                  }
                  icon={<UserOutlined />}
                  size={64}
                  alt={'avatar'}
                />
                <Upload
                  method={'post'}
                  accept={'image/*'}
                  showUploadList={false}
                  onChange={(e) => {
                    setImageUrl(e.file.originFileObj);
                  }}
                >
                  <Button
                    style={{ marginTop: '10px', width: 100 }}
                    className="my_preference_profile_block_second_block_button"
                  >
                    EDIT LOGO
                  </Button>
                </Upload> */}
                <div style={{ width: '50%' }}>
                  <Upload
                    style={{ width: 100, height: 100 }}
                    name="avatar"
                    showUploadList={false}
                    accept="image/png, image/gif, image/jpeg"
                    onChange={handleUploadImage}
                  >
                    {imageUrl !== null ? (
                      typeof imageUrl === 'string' ? (
                        <img
                          src={imageUrl}
                          alt="logo"
                          style={{
                            height: 100,
                            width: 100,
                            borderRadius: '50%',
                          }}
                        />
                      ) : (
                        <img
                          src="/assets/company.svg"
                          alt="logo"
                          style={{
                            height: 100,
                            width: 100,
                            borderRadius: '50%',
                          }}
                        />
                      )
                    ) : (
                      <img
                        src="/assets/company.svg"
                        alt="logo"
                        style={{ height: 100, width: 100, borderRadius: '50%' }}
                      />
                    )}
                  </Upload>
                  <Button
                    style={{
                      marginTop: 32,
                      marginLeft: 24,
                      background: '#FFE1E1',
                    }}
                    type={'text'}
                    color={'#EF6C6C'}
                    shape={'circle'}
                    icon={
                      <img src="/icons/delete_button.svg" alt="delete_button" />
                    }
                    onClick={() => {
                      handleDeleteImage();
                    }}
                  />
                </div>
              </div>
              <span
                style={{ color: '#000000', marginTop: '100px' }}
                className="general_settings_employee_container_text"
              >
                Support Contact
              </span>
              <div style={{ display: 'flex', width: '100%', gap: 32 }}>
                <div style={{ width: '50%' }}>
                  <CustomInput
                    type="tel"
                    // pattern="[0-9]*"
                    // onKeyDown={handleKeyDown}
                    maxLength={20}
                    value={(data as any)?.support_contact}
                    width="100%"
                    onChange={(e) => {
                      const updatedData = {
                        ...data,
                        support_contact: e.target.value,
                      };
                      setData(updatedData);
                    }}
                    // inputMode="numeric"
                    // controls={true}
                    title="Support Contact Number"
                  />
                </div>
                <div style={{ width: '50%' }}>
                  <CustomInput
                    onKeyPress={(e: React.KeyboardEvent<HTMLInputElement>) => {
                      const allowedChars = /^[a-zA-Z0-9@_.]+$/;
                      if (!allowedChars.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    error={data?.support_email && !validateEmail(data?.support_email)}
                    maxLength={50}
                    value={(data as any)?.support_email}
                    width="100%"
                    onChange={(e) => {
                      const updatedData = {
                        ...data,
                        support_email: e.target.value,
                      };
                      setData(updatedData);
                    }}
                    title="Support Email Address"
                  />
                  {(data?.support_email && !validateEmail(data?.support_email)) && <div
                    style={{
                      fontSize: 10,
                      color: '#E02C2C',
                      fontWeight: 500,
                      marginTop: 2,
                    }}
                  >
                    {`"Support Email Address" is invalid.`}
                  </div>}
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default CustomizeDesign;
